import { render, staticRenderFns } from "./PersonalityHowToUse.vue?vue&type=template&id=6893c53a"
import script from "./PersonalityHowToUse.vue?vue&type=script&lang=js"
export * from "./PersonalityHowToUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports